angular.module('picmonicng').controller('EditSiteSettingsController', [
  '$scope',
  'UserService',
  'User',
  'PermissionsService',
  'toaster',
  'ResetSpacedRepModal',
  function ($scope, UserService, User, PermissionsService, toaster, ResetSpacedRepModal) {
    $scope.updated_success = false;
    $scope.password_error = false;
    $scope.PermissionsService = PermissionsService;
    $scope.UserService = UserService;
    $scope.ResetSpacedRepModal = ResetSpacedRepModal;
    $scope.postLearnActions = [
      { label: 'Switch Audio Then Quiz Picmonic', value: 'switch_then_quiz' },
      { label: 'Quiz Picmonic', value: 'quiz' },
      { label: 'Do Nothing', value: 'nothing' },
    ];
    $scope.user = {};
    $scope.communityContentInSearchTooltipText =
      'Did you know you can create your own Picmonics? The Picmonic Creator provides a step-by-step wizard ' +
      'for anyone to create Picmonics with your own facts, animations, and audio. By toggling this setting on, you can access community-created Picmonics ' +
      'when searching for topics. Dive into a wealth of shared knowledge tailored to enhance your learning experience!';

    angular.copy(UserService.user, $scope.user);
    $scope.$emit('endInteraction');

    $scope.resetDemoAccount = function () {
      User.resetDemoAccount().$promise.then(function () {
        window.location.reload();
      });
    };

    $scope.saveSiteSettings = function () {
      if (!$scope.loading) {
        $scope.loading = true;

        for (a in $scope.user) {
          UserService.user[a] = $scope.user[a];
        }

        if (UserService.user.password_new) {
          var change_request = {
            resource: 'change_password',
            password_new: UserService.user.password_new,
            password_current: UserService.user.password_current,
            password_confirmation: UserService.user.password_confirmation,
          };

          User.update(change_request).$promise.then(
            function () {
              $scope.password_error = false;
              UserService.user.$update().then(
                function () {
                  $scope.updated_success = true;
                  $scope.loading = false;
                  angular.copy(UserService.user, $scope.user);
                },
                function (error) {
                  $scope.updated_success = false;
                  $scope.loading = false;
                }
              );
            },
            function (error) {
              $scope.password_error = error.data.message;
              $scope.loading = false;
            }
          );
        } else {
          UserService.user.$update().then(function () {
            $scope.updated_success = true;
            $scope.loading = false;
            angular.copy(UserService.user, $scope.user);
          });
        }
      }
    };

    $scope.updateSliderSettings = debounce(function () {
      $scope.updateSettings();
    }, 1000);

    $scope.updateSettings = debounce(function () {
      UserService.user.$update().then(function () {
        toaster.success('', 'Your settings have been updated.');
        $scope.spaced_rep_queue_max = UserService.user.settings.spaced_rep_queue_max;
        $scope.spaced_rep_round_max = UserService.user.settings.spaced_rep_round_max;
      });
    }, 500);

    $scope.spaced_rep_queue_max = UserService.user.settings.spaced_rep_queue_max;
    $scope.spaced_rep_round_max = UserService.user.settings.spaced_rep_round_max;

    $scope.updateSpacedRepSettings = function () {
      if ($scope.spacedrepsettings.$invalid || $scope.spacedrepsettings.$pristine || $scope.spaced_rep_queue_max < 20) {
        return;
      }

      UserService.user.settings.spaced_rep_queue_max = $scope.spaced_rep_queue_max;
      UserService.user.settings.spaced_rep_round_max = $scope.spaced_rep_round_max;

      $scope.updateSettings();
    };
  },
]);
